import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { NuqsAdapter } from 'nuqs/adapters/react';
import Page from '../app/page';
import '../styles/index.scss';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<NuqsAdapter>
			<Page />
		</NuqsAdapter>
	</StrictMode>
);
